import { USER } from 'src/hooks/useLogin';

export function getCurrentUser () {
  const user = sessionStorage.getItem(USER);
  return user ? JSON.parse(user) : null;
}
